import { useLocalStore } from 'mobx-react';
import { transcribe as transcribeModal } from '@/models';
import { TranscribeStatus } from '../../component/ControlBar/PC/TranscribeBtn';
import { useIntl } from 'umi';
import { message } from '@/components';
export enum TreatmentStatus {
  open = 1, //允许请求
  refuse = 2, // 拒绝请求
}
export interface hostTranscriptionData {
  channelId: number;
  treatment: TreatmentStatus;
}
export default function useTranscribeChange() {
  const { formatMessage } = useIntl();

  const change = async (body: hostTranscriptionData) => {
    if (body.treatment === TreatmentStatus.refuse) {
      message.info({
        content: formatMessage({ id: 'refuseToEnableTranscription' }),
        noIcon: true,
      });
    }
  };

  return change;
}
